import SurveyList from './SurveyList.jsx';

export default SurveyList;